import './scrolling-sidebar.html.twig';
import './scrolling-sidebar.scss';

export default function () {
  const scrollElement = document.querySelector('.scrolling-sidebar');
  const contentElement = document.querySelector('.event-page-content__body');
  if (!scrollElement || !contentElement) return;

  const scrollList = scrollElement.querySelector('.scrolling-sidebar__list');

  const H2s = contentElement.querySelectorAll('h2');
  H2s.forEach((H2, index) => {
    H2.id = `event-heading-${index}`;
    const newScrollItem = document.createElement('li');
    newScrollItem.classList.add('scrolling-sidebar__item');
    const newScrollLink = document.createElement('a');
    newScrollLink.classList.add('scrolling-sidebar__link');
    newScrollLink.setAttribute('href', `#${H2.id}`);
    newScrollLink.innerText = H2.innerText;
    newScrollLink.setAttribute('aria-label', H2.innerText);
    newScrollItem.appendChild(newScrollLink);
    scrollList.appendChild(newScrollItem);

    if (index === 0) {
      newScrollLink.classList.add('scrolling-sidebar__link--active');
    }
  });

  // Set active section on scroll
  function navHighlighter(sections) {
    const windowTop = 50;

    sections.forEach((current) => {
      const sectionTop = current.getBoundingClientRect().top;
      const sectionId = current.getAttribute('id');

      if (sectionTop <= windowTop) {
        const active = document.querySelectorAll('.scrolling-sidebar__link--active');
        active.forEach((el) => {
          el.classList.remove('scrolling-sidebar__link--active');
        });
        document
          .querySelector('.scrolling-sidebar__item a[href*=' + sectionId + ']')
          .classList.add('scrolling-sidebar__link--active');
      } else {
        document
          .querySelector('.scrolling-sidebar__item a[href*=' + sectionId + ']')
          .classList.remove('scrolling-sidebar__link--active');
      }
    });
  }

  const sections = contentElement.querySelectorAll('h2[id]');
  const fisrtSection = sections[0];

  window.addEventListener('scroll', () => {
    if (fisrtSection.getBoundingClientRect().top <= 0) {
      navHighlighter(sections);
    }
  });
}
